import { Link } from 'react-router-dom';
import { videoCollections } from '@/mocks/videos';

export default function CollectionSection() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选视频合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心整理的视频合集，一站收藏你喜欢的精彩内容
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {videoCollections.map((collection) => (
            <Link
              key={collection.id}
              to={`/article/${collection.id}`}
              className="group block rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 overflow-hidden"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={collection.thumbnail}
                  alt={collection.title}
                  title={collection.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                    {collection.platform}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-foreground-700 text-xs">
                    {collection.count} 个视频
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2 mb-2">
                  {collection.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {collection.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {(collection.views / 10000).toFixed(1)}万 次播放
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i> {collection.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}